import interact from 'interactjs';

export class ResizeOptions {

  edges: object;
  modifiers: any[];
  inertia: boolean;

  constructor(minWidth: number | string, minHeight: number | string, floating: boolean) {

    this.edges = {
      left: true,
      right: true,
      bottom: true,
      top: true
    };

    this.modifiers = [
      interact.modifiers.restrictEdges({
        outer: 'body',
        endOnly: floating,
      }),

      interact.modifiers.restrictSize({
        min: {
          width: minWidth,
          height: minHeight,
        },
      }),
    ];

    this.inertia = floating;

  }

}
